function initPublications() {


    const publications =  document.querySelectorAll('.publication-single');


    function initItemHover() {

      publications.forEach(publication => {


        const itemTrigger           = publication.querySelector('.trigger');
        const publicationHover      = publication.querySelector('.btn-hover-plus');
        const closeTrigger          = publication.querySelector('.close-publication-info'); 
        const downloadTrigger       = publication.querySelector('.download-publication-btn'); 
        
 
        if (downloadTrigger) {
            downloadTrigger.addEventListener('click', function(e){

                e.preventDefault();
                const downloadLink = downloadTrigger.href;
                window.open(downloadLink, 'Download');  
                

            });
        }


        const tl2 = new TimelineMax({paused:true});

        // create tweens for timeline
        //tl.to(gridItemCaption, 0.3, {y: 0, ease: Power1.easeIn});
        tl2.to(publicationHover, 0.3, {opacity: 1, scale: 1.1, ease: Power1.easeIn});

        itemTrigger.addEventListener('mouseenter', function(){
          //tl.play();
          tl2.play();
        });

        itemTrigger.addEventListener('mouseleave', function(){
          //tl.reverse();
          tl2.reverse();
        });


        itemTrigger.addEventListener('click', function(e){

            e.preventDefault();

            openPublicationInfo(publication);

        });

        closeTrigger.addEventListener('click', function(e){

            e.stopPropagation();
            e.preventDefault();

            closePublicationInfo(publication);

        });



      });

    }

    function openPublicationInfo(publication){


        const publicationCaption    = publication.querySelector('.publication-caption');
        //const anchor                = publication.querySelector('a');

        publication.classList.add('active');
        publicationCaption.style.display = 'block';

        publications.forEach(publication => {

            if (publication.classList.contains('open') && !publication.classList.contains('active')) {

                closePublicationInfo(publication);
            }

        });


        gsap.to(publicationCaption, {ease: Power1.easeOut, y: 0,  duration: 0.6, onComplete(){

            publication.classList.add('open');
            publication.classList.remove('active');
            //anchor.style.height = '0px';

        }});



    }

    function closePublicationInfo(publication){



        const publicationCaption = publication.querySelector('.publication-caption');
        //const anchor                = publication.querySelector('a');

        gsap.to(publicationCaption, {ease: Power1.easeOut, y: '100%',  duration: 0.6, onComplete(){

            publication.classList.remove('open');
            publicationCaption.style.display = 'none';
            //anchor.style.height = 'auto';

        }});

    }



    initItemHover();

}
